class RecruitJs {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {
    $('.js-rectuitAco').click(function() {
      $(this).next().next().slideToggle();
    })
  }
}
